import { useState } from 'react';

export type ExtendedPanel = 'CLOSED' | 'NOTES' | 'REPORT';

const usePanelSelected = () => {
    const [panelSelected, setPanelSelected] = useState<ExtendedPanel>('CLOSED');

    return {
        panelSelected,
        setPanelSelected,
    };
};

export default usePanelSelected;
